import Vue from 'vue'

export function initComponents() {
    Vue.component('Dropdown', () => import('primevue/dropdown'))
    Vue.component('Calendar', () => import('primevue/calendar'))
    Vue.component('Button', () => import('primevue/button'))
    Vue.component('InputText', () => import('primevue/inputtext'))
    Vue.component('InlineMessage', () => import('primevue/inlinemessage'))
    Vue.component('Message', () => import('primevue/message'))
    Vue.component('Textarea', () => import('primevue/textarea'))
    Vue.component('InputSwitch', () => import('primevue/inputswitch'))
    Vue.component('InputLocation', () => import('@/components/forms/InputLocation'))
    Vue.component('InputQueue', () => import('@/components/forms/InputQueue'))
    Vue.component('InputTime', () => import('@/components/forms/InputTime'))
    Vue.component('InputDate', () => import('@/components/forms/InputDate'))
    Vue.component('InputName', () => import('@/components/forms/InputName'))
    Vue.component('InputPhone', () => import('@/components/forms/InputPhone'))
    Vue.component('InputEmail', () => import('@/components/forms/InputEmail'))
    Vue.component('InputComment', () => import('@/components/forms/InputComment'))
    Vue.component('InputCaptcha', () => import('@/components/forms/InputCaptcha'))
    Vue.component('InputPersonalData', () => import('@/components/forms/InputPersonalData'))
    Vue.component('InputConfirmCode', () => import('@/components/forms/InputConfirmCode'))
}
